import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Alert } from "@mui/material";
import { IPartnerDto } from "src/shared/types/partner.types";
import { getIntegration1CStatus } from "../lib/GetIntegration1CStatus";
import { INTEGRATION_1C_MESSAGES } from "../model/constants";

interface Props {
  integration_1c?: IPartnerDto["integration_1c"];
}

export function Partner1CStatusAlert({ integration_1c }: Props) {
  const status = getIntegration1CStatus(integration_1c);

  if (status === "SUCCESS" || status === "ERP_ONLY") return null;

  const isQueue = status === "IN_QUEUE";

  const severity = isQueue ? "warning" : "error";
  const icon = isQueue ? <ErrorOutlineIcon /> : <HighlightOffIcon />;

  return (
    <Alert severity={severity} icon={icon} sx={{ mb: 5 }}>
      {INTEGRATION_1C_MESSAGES[status].text}
    </Alert>
  );
}
